import React from "react";
import { Link } from 'react-router-dom';
import StarRatingComponent from 'react-star-rating-component';
import Slider from 'react-slick';
import Axios from 'axios';

const reviews = [
    {
        first_name: 'Deborah',
        last_name: 'Ramirez',
        review: 'This is our fourth pup to be raised on Lotus Kibble. Our Shih Tzu lived to be a healthy 17 year old. Out other pups are 13 and 10 and are really young and healthy on the Duck Recipe. Benson will eventually switch over to that but it is important to get the extra nutrients now that the Puppy formula offers. Hes a active six month old! Loves this good!',
        review_date: '09/07/20',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/1.jpg',
        link: '/product-view/dog/regular-bites/Chicken%20Puppy-4',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/puppy%2020lbs%20front%201920-640-02-17-2020.png',
      },
      {
        first_name: 'Rene',
        last_name: 'Hersey',
        review: `My 17+ year young Abytabby (Abyssinian-Orange tabby) has thyroid/heart issues controlled successfully by medication. My vet & I wanted her to maintain muscle mass/get nutrients for her heart & enjoy her senior days. On top of all that she had a bit of flare up in pancreas.  Working w my vet we introduced the Lotus Lamb Recipe for Cats & I’ve got to say, it was an immediate hit, 1st meal! I warm it for 12 secs so she can smell it, and she’s off to the races. She also cannot tolerate fish/seafood so, again, this recipe is appropriate for her. This recipe and sourcing in U.S./California was primary to us. Our girl is soo enjoying every meal (we add digestive enzymes + probiotics) & her digestion is great & deification is perfect. We’re going to try the chicken recipe next. Thank you Lotus for creating these simple recipes which allow for more cats to eat highly digestible & delicious meals every day!`,
        review_date: '05/26/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/2.jpg',
        link: '/product-view/cat/raw-food/Lamb-54',
        image:'https://lotus-pet-foods.s3-us-west-1.amazonaws.com/Cat+Food/Rawfood/lamb/24oz/lamb+640.png',
      },
      {
        first_name: 'Christian',
        last_name: 'Pacheco',
        review: `My 12 year old JRT is a big eater. We were having issues with his weight and he would often choke because he would eat so quickly. We then found Lotus Small Bites. While he does love other flavors, as a good dog owner; I know he really loves the duck formula. It gives him a nice skin and coat, and the 4lb bag last my little fella a good amount of time. Lotus knocked it out the park with this one! IT’S QUACKTASTIC!`,
        review_date: '12/01/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/3.jpg',
        link: '/product-view/dog/small-bites/Duck-45',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/duck%20SB%2011lbs%20front%201920-640-02-17-2020.png',
      },
      //////////////////////////////////

      {
        first_name: 'Joanne',
        last_name: 'Costa',
        review: `Thank you Lotus for creating Venison Just Juicy. My rescue kitty Parker was found abandoned on the streets and in really bad shape.
        My neighbor was fostering her and I quickly fell in love with her. It was clear she suffered from severe allergies and I was determined to get to the bottom of her allergies after I adopted her.
        It was suggested that she could be allergic to chicken and fish as these are 2 of the most common pet allergies. When I discovered that Just Juicy Venison was only venison with no other protein, I decided to give it a try. Keep in mind I had tried several other allergy pet foods over the course of a year with no success.
        Within 10 days of using the Just Juicy Venison, Parker was a completely different cat after suffering from severe allergies for at least 3 years. No more sneezing, congestion, paw chewing, constant licking her back side. It is unbelievable. We measure Parker’s food because she will eat everything she gets. I have found if you over feed this food, meaning more than the recommended amount for your cats weight, they can get a upset stomach with soft stool. This happened to my other 2 cats. But for Parker, she thrives on this food as long as we don’t over feed her. She’s now living her best life. We are forever grateful.`,
        review_date: '12/02/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/4.jpg',
        link: '/product-view/cat/juicy/Venison-28',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/venison%205oz-640-02-18-2020.png',
      },

      {
        first_name: 'Natalie',
        last_name: 'Almanza',
        review: `Having 9 cats, I want the best for them. Lotus is that for my cats!! We feed them the venison as one of my cats has a beef allergy. The consistency of the batches is awesome! ( we know cats are picky eaters, lol) Our cats love it and we love that Lotus makes such an amazing product! 10/10 would recommend!! `,
        review_date: '12/01/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/5.jpg',
        link: '/product-view/cat/raw-food/Venison-55',
        image:'https://lotus-pet-foods.s3-us-west-1.amazonaws.com/Cat+Food/Rawfood/venison/24oz/venison+640.png',
      },
      
      {
        first_name: 'Dianne',
        last_name: 'Lamb',
        review: `I am so thankful I discovered Lotus Just Juicy! I have rescue kitties from 5 - 18.5 yo and it was especially hard to get my oldest kitty to eat sometimes, until I tried this. Feel very blessed to have found something that is not only good for her but that she eats - they all deserve the best`,
        review_date: '12/20/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/6.jpg',
        link: '/product-view/cat/juicy/Pork-10',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/pork%205oz-640-02-17-2020.png',
      },
      //////////////////////////////////

      {
        first_name: 'Lynnie',
        last_name: 'Tracy',
        review: `We have served different wet foods over the years but NONE have caused my dog to continuously lick her bowl clean except Lotus. The green tripe is her favorite flavor but she won’t pass on duck or rabbit flavors either! `,
        review_date: '01/22/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/7.jpg',
        link: '/product-view/dog/loaf/Tripe-32',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/tripe-1920-640-02-17-2020.png',
      },
      {
        first_name: 'Bill',
        last_name: 'Raffio',
        review: `Lotus Turkey Oven Baked Kibble is the food of choice for my French Bulldog family of 7. From 4 months to 11 years old. Four generations of beautiful top winning show dogs. All thriving and loving meal time. `,
        review_date: '12/16/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/8.jpg',
        link: '/product-view/dog/regular-bites/Turkey-13',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/turkey%2020lbs%20front%201920-640-02-17-2020.png',
      },
      {
        first_name: 'Christy',
        last_name: 'Harbaugh',
        review: `We started a raw diet with our puppies as soon as we got them.Using the food recommended by their Veternarian.They recently were tired of the same old food. Our local Healthy Pet Product store recommended trying the Lotus Beef Raw food! They Love It. It’s complete and balanced So I don’t have to worry that they aren’t getting everything they need to stay healthy! Thank you so much for making our meal time easy for me and yummy for them! `,
        review_date: '12/21/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/9.jpg',
        link: '/product-view/dog/raw-foods/beef-61',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/beef%201920-01-25-640-08-27-2020.png',
      },
      ////////////////////////////////

      {
        first_name: 'Prince',
        last_name: 'George',
        review: `Prince George is part Dalmatian, part white Lab, a mixed breed and we were lucky enough to rescue the crowned Prince from a shelter and give him a loving home. Once upon a time Prince George’s mom & dad was very sad as after about 8 months of eating food from the big blue bag, he developed terrible diarrhea daily and finally stopped eating as he could no longer tolerate it for some strange reason. After trying many alternate kinds of their food, the folks who make the big blue bag of food sadly had come to the conclusion that they no longer had a food that would be suitable for the healthy strapping growing Prince who had stopped eating their foods and none of the foods that Mom & Dad were bringing home seemed to satisfy the royal Prince’s appetite. Mom and Dad tried everything from Grain-Free to canned and everything in between and the Prince would lick it, smell it and turn his nose up at it. :-( The Prince had become a very finicky eater and was not eating enough for him to develop normally, So Mom & Dad knew they had to do something because they knew how important it was for their young growing Prince to get a wholesome meal so he could grow up to be big and strong enough to run and carry around a ball on his own. One day the Vet suggested that Mom & Dad try going to the doggy boutique where royalty shops and came home with at least a dozen bags of food fit for royalty and let him decide. So Mom & Dad brought home a bunch of trial bags for Prince George. Allowing the finicky little Prince to pick out his own food. At first Prince George didn’t know what to make of it when he first saw all these food bowls, Oh my he thought, this could be a lot of fun! After about 30 minutes of licking and smelling all the bowls (apparently the young Prince knew the secret to releasing all the flavor in the food was to lick it first and then sniff it to see if the food was really worthy of royalty) he narrowed his choices down to 3 bowls that he kept coming back to lick and sniff. He still hadn’t even tasted the foods yet as he first had to make sure that they were truly worthy to be consumed by royalty. He then finally went back to his final 3 choices and started nibbling at each one going from bowl to bowl and then back for a second tasting. After another 10 minutes he finally decided on a Winner and polished off the entire bowl! The choice of the Prince was (drum roll) Lotus Chicken Adult Kibble, truly food fit for royalty…as it had passed the lick and sniff tests to beat out all others! Fast forward to today, 62lbs and 4 years later. Prince George has grown into a handsome muscular healthy ball player and still has a ravenous appetite for his favorite and still ONLY CHOICE for royalty, Lotus Chicken Adult Kibble! …and so the crowned Prince has finally found his true love of foods and is living happily ever after thanks to the folks at Lotus! Prince George, Mom & Dad send a huge shout out of thanks to the loving folks at Lotus for making a recipe fit for a king by creating a healthy delectable alternative food filled with TLC that can truly satisfy even the finickiest of royalty!`,
        review_date: '04/08/19',
        stars: 5,
        avatar: 'null',
        product: 'https://s3-us-west-1.amazonaws.com/lotus-reviews/10.jpg',
        link: '/product-view/dog/regular-bites/Chicken%20Adult-6',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/chicken%2020lbs%20front%201920-640-02-17-2020.png',
      },
      {
        first_name: 'Moyca',
        last_name: 'Gardasevich',
        review: `We had been searching for for healthy food without corn meal, without animal byproducts, preferably no chicken and low on grains. We were recommended Lotus by experienced store that specializes in high quality dog food. That was more than 10 years ago and we never feed our dogs any other food. We switched to few different flavors as long they meet our criteria. But Lamb is our favorite. Our dogs like it, they are healthy and thriving. We recommended it to all our friends. If you are looking for nutritious, healthy food for your dog , this is it.`,
        review_date: '12/01/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/11.jpg',
        link: '/product-view/dog/regular-bites/Lamb-5',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/lamb%2020lbs%20front%201920-640-02-17-2020.png',
      },
      {
        first_name: 'ROBERTA',
        last_name: 'GOTTLIEB',
        review: `I am the founder and director of a senior and special needs small dog rescue and feed these dogs Lotus Senior Small Bites.  The food is easy for them to digest and  since it is baked, they are able to metabolize the nutrients from the healthy ingredients.  I recommend Lotus to all of my adopters!  And I love the fact that it’s a small company that is focused on quality and has never had a product recall.  It’s all about helping these long neglected little dogs reach their highest potential! `,
        review_date: '12/22/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/12.jpg',
        link: '/product-view/dog/small-bites/Chicken%20Senior-21',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/senior-SB-11lbs-front-1920-640-02-17-2020.png',
      },
      ////////////////////////////////////

      {
        first_name: 'Dennis',
        last_name: 'Lumpkin',
        review: `My Dexter is 15 years old and had to have many of his teeth removed.  I have bought the regular food for several years but switched to the small bites which works so well for all his needs.  I love all the ingredients and their health benefits for both my dogs.  Very low Vet bills because of this healthy diet.`,
        review_date: '12/20/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/13.jpg',
        link: '/product-view/dog/small-bites/Chicken%20Senior-21',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/senior-SB-11lbs-front-1920-640-02-17-2020.png',
      },
      {
        first_name: 'Katie',
        last_name: 'Gelacio',
        review: `My 17year old Bengal suffered from severe IBD, RIP. She was allergic to everything it seemed except Lamb. I vowed once we adopted our boy ThunderStorm. I would make my own food "raw" wow, that's a lot of work! Thankfully after much research and also reading that the "All about Cats" website reported Lotus as minimal if any recalls on raw food. Nor to mention hormone and antibiotic free, as well as range free Lamb. My boy loves it and it's so nice to feed him raw food I trust. He's 1 year now and in perfect health! He's been eating Lotus Raw Lamb since we've adopted him and his sister will too once she arrives. `,
        review_date: '10/24/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/14.jpg',
        link: '/product-view/cat/raw-food/Lamb-54',
        image:'https://lotus-pet-foods.s3-us-west-1.amazonaws.com/Cat+Food/Rawfood/lamb/24oz/lamb+640.png',
      },
      {
        first_name: 'Christie',
        last_name: 'Houzenga',
        review: `Hi! I just have to share this with your company because I think you have an amazing product: On February 7, 2020, I started feeding my dog, Chevy (age 4), your Good Grains Chicken Recipe Oven-Baked Adult Dry Food, and it has made a HUGE difference in his overall well-being! He is definitely calmer and happier now than when I was feeding him Iams, but it’s hard to show that visually in a photo. His coat is richer in color and very soft and shiny, and he has actually gained about 15 lbs that he needed to gain in about 9 months. He is a male Great Pyrenees/lab mix so he should weigh about 80-90 lbs, which he weighs about 80 now. Prior to feeding him your food, he weighed about 65 pounds and looked very gangly, but his vet wasn’t concerned. Chevy is a grazer and eats when he is hungry, so I know he wasn’t underfed because he hardly finishes his food all the way, even now. Fast forward to today, he looks amazing. He has always been a beautiful boy, but I think you can really tell a difference in these photos. The photo where he is looking at the camera was Thanksgiving 2019 and the other photo where he is looking straight ahead was Thanksgiving 2020.  He is pure lean muscle with a thick, full coat. I can’t believe his transformation, and I am so happy my mom introduced me to your company; I can confidently credit his food for the positive changes he’s experienced. Chevy deserves the best and that’s what he’s getting! Thank you for putting such a great product out into the world! 🤍`,
        review_date: '11/30/20',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/15.jpg',
        link: '/product-view/dog/regular-bites/Chicken%20Adult-6',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/chicken%2020lbs%20front%201920-640-02-17-2020.png',
      },
      //////////////////////////////////

      {
        first_name: 'Lisa',
        last_name: 'Verlo',
        review: `We have two very picky Ragdoll cats and they both go nuts for Venison stew. It is perfect because it is also something they both agree on as one of our cats has a food allergy to chicken. They also like the stew over pate. Paws down one of their favorite meals.`,
        review_date: '12/21/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/16.jpg',
        link: '/product-view/cat/juicy/Venison-28',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/venison%205oz-640-02-18-2020.png',
    },
    {
        first_name: 'Nisha',
        last_name: 'Max',
        review: `I've been feeding Lotus to my dog his entire life. Now that he is a senior boy 10yrs old we have on the senior plan. He's thriving and happy. No one ever believes he's 10 years old he's still jumping and running around with ease. Deffinetly the best decision we have made for his nutrition `,
        review_date: '12/02/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/17.jpg',
        link: '/product-view/dog/regular-bites/Chicken%20Senior-53',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/senior%2020lbs%20front%201920-640-02-18-2020.png',
    },
    {
        first_name: 'Adrian',
        last_name: 'Schirr',
        review: `My sweet Treeny girl used to get terrible bouts of pancreatitis. It didn’t matter what we fed her. It seemed like once per month she was lathargic, couldn’t eat, and in pain. I was so defeated—I felt like I was failing her. I finally walked into a local all natural pet store and she recommended the Lotus brand for senior dogs. That was 3 year ago. Today I have a healthy, active 14 yr old girl! This is the ONLY food for her.`,
        review_date: '04/21/2019',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/18.jpg',
        link: '/product-view/dog/regular-bites/Chicken%20Senior-53',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/senior%2020lbs%20front%201920-640-02-18-2020.png',
    },
    ////////////////////////////////

      {
        first_name: 'Diane',
        last_name: '',
        review: `I recently learned one of my kitties has early CKD and low phosphorus diet was recommended.  Its a great alternative to prescription renal diet cat food.`,
        review_date: '12/01/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/19.jpg',
        link: '/product-view/cat/juicy/Turkey-25',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/turkey%205oz-640-02-18-2020.png',
      },
      {
        first_name: 'Shannon',
        last_name: 'McClure',
        review: `My cat has been incredibly happy with all of the lotus products but especially enjoys this pate.`,
        review_date: '12/01/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/20.jpg',
        link: '/product-view/cat/pate/Pork-30',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/pork-12oz-640-02-17-2020.png',
      },
      {
        first_name: 'David',
        last_name: 'Adams',
        review: `My dog loves the turkey and fish kibbles. She is a very healthy dog.thanks in part to Lotus!`,
        review_date: '12/20/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/21.jpg',
        link: '/product-view/dog/regular-bites/Turkey-13',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/turkey%2020lbs%20front%201920-640-02-17-2020.png',
      },
      
      //////////////////////////////////
      

    {
        first_name: 'Beverly',
        last_name: 'Landgraf',
        review: `I have a Standard poodle, Coco, who is a very picky eater. I can’t even began to tell you how many she has tried. Funny thing is she is a big dog but only likes small bite kibble, which is hard to find for large dogs.   I tried Lotus chicken for that reason and also because my daughter’s dog who is a fussy eater as well loves Lotus dog food.  I am happy to say Coco loves it as well.`,
        review_date: '12/20/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/22.jpg',
        link: '/product-view/dog/regular-bites/Chicken%20Adult-6',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/chicken%2020lbs%20front%201920-640-02-17-2020.png',
    },
    {
        first_name: 'Pamela',
        last_name: 'Macready',
        review: 'My boy is so picky about his food and your Venision is our go to food for him. He will only drink the juice, but I am happy to give it to him. My girl eats the rest of the solid pieces. Thank you for making our lives easier by providing this product. It is a very high quality food.',
        review_date: '06/29/20',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/23.jpg',
        link: '/product-view/cat/juicy/Venison-28',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/venison%205oz-640-02-18-2020.png',
    },
    {
        first_name: 'Deborah',
        last_name: 'Ramirez',
        review: 'I started using Lotus Kibble over 20 years ago. My Shih Tzu lived to be 17! My current pups are  13, 10 and six months. The older two have been on the Duck recipe their entire life. Ive thought about changing to the senior recipe but one itches when he eats chicken so??? The pup is currently on the puppy recipe but I will switch over when is he older.',
        review_date: '09/07/20',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/24.jpg',
        link: '/product-view/dog/regular-bites/Duck-20',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/duck%2020lbs%20front%201920-640-02-17-2020.png',
    },
    //////////////////////////

      {
        first_name: 'Samantha',
        last_name: 'Valladares',
        review: `My career goals aside, I have worked as a passionate and perhaps even excessively concerned dog mommy of a working kelpie with ensuring my dog gets only the best of the best, trust me when I say I KNOW about dogs both inside and outside the clinic and in retail boutiques and retail stores....and even go as far as subscribing myself to the latest vet research magazines and pet business magazines promoting products for retail stores and other boutique dog stores that are couture and sell the priciest food...and educating myself for hours on end., I one day went on a whim and bought this brand and have never ONCE had any doubt in my mind as to how this is without a shadow of a doubt the BEST dog food. You've probably heard time and time again that greens are bad and that chicken is some thing that dogs are allergic to know that is not true and there's a lot of miss information out there and overly wide sweeping generalization but the truth of the matter is that grains of Accord into a veterinarian who was a coworker of mine made it very very very well known and every single asking about making sure that pet parents informed that not eating grain causes cardio cardiological problems so fact check #1: GRAINS ARE GREAAAT! and #2 myth debunk?? A lot of people somehow I think it's a fancy to be late I guess no chicken is the new light vegetarian thing and it's not about being gluten-free and are trending so you have to set that aside and really know what you're talking about because while it is true some dozen more prone to allergies and poultry out of thisA lot of people somehow I think it's a fancy to be late I guess no chicken is the new light vegetarian thing and it's not about being gluten-free and all trendy so you have to set that aside and really know what you're talking about because while it is true some dozen more prone to allergies and poultry allergies I do understand that, but it is ALSO true to opt for sardines, and the other ingredients I have never known up until just now that come with these more RARE CONFRONTATIONS WITH THESE FOODS!!=NO EXPOSURE OR LESS EXPOSURE?? = NO ALLERGIES ! So the truth is you cannot have an allergy to an animal or something you have never been exposed to or likely exposed to if you imagine wolves for instance ; it is easy  Tell mistakingly but yet rightfully presumed that because chickens are more easy to come across in the wild that the lineage of the animal probably have developed a chicken allergy but that's not the case and I do tend to sometimes up for my exotic foods but I mean unless their skin gets rather than have a reaction you notice that their tummy gets red or some thing then I would be concerned or French bulldogs or any kind of dog that might require more hypo minimal ingredients i would say sardines for the later and also for purposes of frenchies and their weight concerns. However, I was looking for the most obscure brands I could find before I knew this was even carried anywhere and lo and behold I've seen it on our website and I made it a point to look up every single brand and do my research I did find one of the products while my dad was a puppy so it has been officially over two years and I've been buying this consistently and while it is pricey it is worth it my dog is extremely picky and while we cook filet mignon it is neither in anyones best interest because of many reasons. So Trust me when I say oh I literally have tried origins high protein so much high-protein could make a dog sick and then there is a course the other brand Acana that people rant and rave about. If you notice and read ingredients,  The ingredient that has the highest quantity and the bag is what needs to be listed first try to find some thing that does not include for the first ingredient chicken meal or chicken by product or synthetic materials like laboratory made like science I am as of course it's medically prescribed and you get it from your veterinarians office that's an exception that's that as an exception but the start the stock food has been my favorite hands-down If you could imagine what it would be like to convert a person who eats human food and the best human food that is in process Frances filet mignon pacifically you know unprocessed cook chicken and turkey and basically something unsustainable and imagine trying to change the human into eating something like dog food this dog is the Analogous to Humane who now has a dog food and get the same health benefits the best of the best this is exactly what you're getting with this food and it is the only one that my dog enjoys they have a puppy size which is good for dogs that are probably up that are not at one years old and therefore may have more trouble but I won't mix it up with some like in our sliders and maybe some primal milk and what not ever so often or broth but it never gets old and it's hand like I will never ever consider anything else so thank you lotus I'm pretty much been there since the inception Of this product if it was within the past three years that you have put it out to retail at all my dads exceptional health and moving to you. #WINNERWINNERCHICKENDINNER`,
        review_date: '10/29/20',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/25.jpg',
        link: '/product-view/dog/regular-bites/Chicken%20Adult-6',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/chicken%2020lbs%20front%201920-640-02-17-2020.png',
      },
      {
        first_name: 'Jayne',
        last_name: 'Miller',
        review: `I have 2 cats with special needs.  One is allergic to chicken and all whitefish.  The venison (& turkey) are what he eats and thrives on.  My other cat has urinary crystals and needs more moisture in his diet.  The Just Juicy products are perfect for him!  Thank you Lotus!`,
        review_date: '12/24/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/26.jpg',
        link: '/product-view/cat/juicy/Venison-28',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/venison%205oz-640-02-18-2020.png',
      },
      {
        first_name: 'Wendy',
        last_name: 'Sherrill',
        review: `I've been feeding Lotus dry food to my two dogs, Monty and Miley, for several years now and they love it. Great for their digestion and they are always excited to eat it! Grateful to have these high quality products available. Thank you!`,
        review_date: '12/26/21',
        stars: 5,
        avatar: 'null',
        product: 'https://lotus-reviews.s3.us-west-1.amazonaws.com/27.jpg',
        link: '/product-view/dog/regular-bites/Chicken%20Adult-6',
        image:'https://lotus-pet-foods-product-images.s3-us-west-1.amazonaws.com/chicken%2020lbs%20front%201920-640-02-17-2020.png',
      },
      ////////////////////////////////
  ];

/*function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", right:-30, top:200}}
        onClick={onClick}
      />
    );
  }
  
  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", left:-109, top:200}}
        onClick={onClick}
      />
    );
  }*/

class CustomerReview extends React.Component {

/*state = {
    allReview:[]
}

componentDidMount() {
    this.getAllReview();
}

getAllReview(){
    //console.log("inside get all review");
    Axios.get('/client/products/get-product-review')
      .then((allreviews) => {
              allreviews.data.map((eachReview) => {
                  console.log(eachReview);
              })
      }
      )
      .catch((err) => {
        console.error(err);
        const { status } = err.res;
        if (status === 500) {
          return error({ title: 'Server Error', text: 'Issue with Server.', button: 'Okay.' });
        }
        error({ title: 'Error', text: 'Cannot get Product info', button: 'Okay.' });
      });
}*/

render() {
    const settings = {
        speed: 500,
        arrows: false,
        autoplay: true,
        adaptiveHeight: true,
        /*nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,*/
        responsive: [
            {
              breakpoint: 8000,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
                breakpoint: 800,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  infinite: true,
                  dots: true
                }
            },
            {
                breakpoint: 400,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: false
                }
            },
        ]
      };

    return(
        <div className="container">
            <div className="row">
            <div className="col-12 text-center">
              <div className="landing-what-customers">WHAT CUSTOMERS ARE SAYING</div>
              <div className="row mb-md-4 mb-2 mx-0" />
            </div>
          </div>
        <Slider {...settings}>
            {reviews.map((review, i) => {
                return (
                        <div>
                            <div key={i} className="row d-flex align-items-center h-100 review-cloud-two" style={{margin:11}}>
                                <div className="col-sm-8" style={{marginTop:20, paddingLeft:30}}>
                                    <div className="row">
                                        <div className="col-auto my-auto" style={{padding:0}}>
                                            {review.avatar === 'null' ? (
                                            <img
                                            className="cloud-avatar"
                                            src={'https://s3-us-west-1.amazonaws.com/lotus-pet-foods/Product+Page/missing.jpg'}                          
                                            />) : (
                                            <img className="cloud-avatar" src={review.avatar} />)}
                                        </div>
                                        <div className="col my-auto px-0 review-name">
                                            <p style={{fontSize:14}}>{review.first_name} {review.last_name}</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col" style={{padding:0}}>
                                            <div className="cloud-stars">
                                                <StarRatingComponent
                                                name="product"
                                                starCount={5}
                                                value={review.stars}
                                                editing={false}
                                                renderStarIcon={(index, value) => {
                                                return (
                                                <span>
                                                <i
                                                className={
                                                    index <= value ? 'fas fa-star' : 'far fa-star'
                                                }
                                                style={{fontSize:15}}
                                                />
                                                </span>
                                                );}}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <a href={review.link}><img className="img-fluid" src={review.image} width="80"/></a>   
                                </div>
                                <div className="col-sm-12">
                                    <div className="row">
                                        <div className="col-12 cloud-text">
                                        {review.review.length <= 132
                                            ? review.review.substring(0, 132)
                                            : review.review.substring(0, 132) + '... '}
                                        {review.review.length > 132 ? (
                                            <Link
                                            to={review.link}
                                            href={review.link}
                                            className="review-read-more cloud-text">
                                            Read More
                                            </Link>
                                        ) : null}
                                        </div>
                                    </div>
                                        
                                    <div className="row mt-3">
                                        <div className="col-12 cloud-text">
                                            <img className="img-fluid" src={review.product} />
                                        </div>
                                    </div>
                                </div>
                                            {/*<div className="col-sm-4 col-8 mx-auto text-center">
                                            <img className="img-fluid" src={review.product} />
                                            <Link to={review.link} href={review.link} className="review-explore">
                                                Explore
                                            </Link>
                                            </div>*/}
                            </div>
                        </div>
                    );})}
        </Slider>                                          
</div>
);}}

export default CustomerReview;

 